import { SingleTableBoxScene } from "@/shared/components/ui";
import { Tab, Tabs } from "@mui/material";
import { a11yProps, EstadoLiberarVentaENUM, texto, useCheckPermissions } from "@/shared";
import { useState } from "react";

import { PermissionsEnum } from "@/auth/interfaces";
import { CustomTabPanel } from "@/erp/sale/component";
import TableAprobarLiberacionProspecto from "../shared/table-aprobar-liberacion-prospecto/TableAprobarLiberacionProspecto";
import TableGeneralLiberacionProspecto from "../shared/table-general-liberacion-prospecto/TableGeneralLiberacionProspecto";

const SupervisionLiberacionVentaProspectoPage = () => {

  useCheckPermissions(PermissionsEnum.api_view_solicituddesbloqueo);

  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene title="Solicitud Liberación de Prospecto">

      <Tabs
        value={valueTab}
        onChange={(_event: React.SyntheticEvent, newValue: number) => {
          setValueTab(newValue);
        }}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        aria-label="scrollable force tabs preventa"
      >
        <Tab label={texto.solicitud} {...a11yProps(0)} />
        <Tab label={texto.aprobado} {...a11yProps(1)} />
        <Tab label={texto.rechazadas} {...a11yProps(2)} />
      </Tabs>

      <CustomTabPanel index={valueTab} value={0}>
        <TableAprobarLiberacionProspecto />
      </CustomTabPanel>
      <CustomTabPanel index={valueTab} value={1}>
        <TableGeneralLiberacionProspecto estado_solicitud={EstadoLiberarVentaENUM.APROBADO} />
      </CustomTabPanel>
      <CustomTabPanel index={valueTab} value={2}>
        <TableGeneralLiberacionProspecto estado_solicitud={EstadoLiberarVentaENUM.CANCELADO} />
      </CustomTabPanel>

    </SingleTableBoxScene>

  );
}

export default SupervisionLiberacionVentaProspectoPage